import { createRoot } from "react-dom/client";

import "./index.css";
import { AppProviders } from "./providers/AppProvider.tsx";

createRoot(document.getElementById("root")!).render(<AppProviders />);
